module.exports = __webpack_public_path__ + "img/testimonials-bg-new.e81c2545.svg";